import { SvgIcon, SvgIconProps } from "@mui/material";

export const SyncIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 20a8 8 0 0 0 7.027-4.175M20 12a8 8 0 0 0-8-8M12 4a8 8 0 0 0-7.027 4.175M4 12a8 8 0 0 0 8 8"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M4.973 8.175A8 8 0 0 1 20 12M4 12a8 8 0 0 0 15.027 3.825"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M8.047 8.175H4.512V4.639M15.953 15.825h3.535v3.536"
      />
    </svg>
  </SvgIcon>
);
